import { Component, Inject, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { PDFExportComponent } from '@progress/kendo-angular-pdf-export';
import { SettingsService } from 'app/services/core/settings.service';
import { SearchLabsService } from 'app/services/searchLabs/searchLabs.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SharedService } from 'app/services/core/shared.service';
import { ICertificateReportMatrixViewModel, ICertificateReportViewModel, IFoaReportViewModel } from 'app/models/report/reports';
import { drawDOM, exportPDF } from '@progress/kendo-drawing';
import { CertificateService } from 'app/services/lab-user-menu/certificate.service';
import { CertificateReportComponent } from '../certificateReport/certificateReport.component';

@Component({
  selector: 'attachedReportFooter',
  templateUrl: './attachedReportFooter.component.html',
  // styleUrls: ['./attachedReportFooter.component.scss']
})

export class AttachedReportFooterComponent {
  
  @ViewChild('pdf') pdf: PDFExportComponent;
  public certData: ICertificateReportViewModel = {} as ICertificateReportViewModel;
  public matrixData: ICertificateReportMatrixViewModel[] = [];
  public uniqueAnalyteNames: string[] = [];
  public certId: number = 0;
  public certList: { matrix: string, foaList: { method: string, foas: IFoaReportViewModel[] }[] }[] = [];
  private file: File = null;

  constructor(public searchLabsService: SearchLabsService,  
    public settings: SettingsService,

    @Inject(MAT_DIALOG_DATA) public data: any
  ) {

  }

  ngOnInit(): void {
  }

}
